import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface PontoCriticoQrCode {
  id: number;
  pontoCriticoId: number;
  publicId: string;
  ativo: boolean;
  dataExpiracao: string | null;
  dataCriacao: string;
  dataAtualizacao: string;
}

export interface PontoCriticoQrCodePage {
  pageSize: number;
  pageNumber: number;
  totalPages: number;
  totalRecords: number;
  records: number;
  data: PontoCriticoQrCode[];
}

@Injectable({ providedIn: 'root' })
export class PontoCriticoQrCodeService {
  private readonly http = inject(HttpClient);
  private readonly endpoint =
    environment.apiurl + '/api/PontoCriticoQrCode';

  getActive(pontoCriticoId: number): Observable<PontoCriticoQrCodePage> {
    const params = new HttpParams()
      .set('PontoCriticoId', pontoCriticoId)
      .set('Ativo', true)
      .set('pageNumber', 1)
      .set('pageSize', 10);

    return this.http.get<PontoCriticoQrCodePage>(this.endpoint, { params });
  }

  generate(pontoCriticoId: number): Observable<unknown> {
    return this.http.post<unknown>(
      this.endpoint + '/' + pontoCriticoId,
      {},
    );
  }

  preview(pontoCriticoId: number): Observable<Blob> {
    return this.http.get(
      this.endpoint + '/' + pontoCriticoId + '/preview',
      { responseType: 'blob' },
    );
  }
}
